module.exports = {
  spDataEndpoint: 'http://localhost:8080/data.json',
  resourcesDataEndpoint: 'http://localhost:8080/resources.json'
}